/**
 * Created by yougen on 3/12/15.
 */
/**
 * Created by yougen on 3/9/15.
 */

    var $ = require("@alife/alpha-jquery/jquery");
    // 普通枚举转义不能满足要求，比如全角情况下的单引号等
    module.exports = {
        encodeHTML: function(value){
            return $('<div/>').text(value).html();
        },
        decodeHTML: function(value){
            return $('<div/>').html(value).text();
        }
    };
